export default {
  // Hero
  build: 'Aktuální build 2.6.1',
  heroTitle1: 'Ověřené herní klíče.',
  heroTitle2: 'Doručení s nulovou latencí.',
  heroSubtitle:
    'Získejte okamžitý přístup k prémiovým herním titulům. Naše brutalistická infrastruktura zajišťuje bezpečné transakce a okamžité odeslání klíče přímo do vašeho terminálu.',
  browseCatalog: 'Procházet katalog',
  howItWorks: 'Jak to funguje',

  // Live metrics panel
  liveMetrics: 'Živé metriky',
  titles: 'Tituly',
  activePlayers: 'Aktivní hráči',
  delivery: 'Doručení',
  verified: 'Ověřeno',

  // Sections
  topPicks: 'Top výběr',
  featuredThisWeek: 'Tento týden doporučujeme',
  viewAll: 'Zobrazit vše',
  selectPlatform: 'Vyberte platformu',
  addToCart: 'Do košíku',
  baseGame: 'Základní hra',
  dlc: 'DLC',
  titlesShort: 'titulů',

  // How it works
  howHeading1: 'Tři kroky.',
  howHeading2: 'Nulové tření.',
  howSubtitle: 'Od procházení k aktivovanému klíči za méně než minutu.',
  step1Title: 'Vyber',
  step1Body: 'Vyberte si požadovaný titul z naší ověřené databáze.',
  step2Title: 'Zaplať',
  step2Body: 'Proveďte bezpečnou transakci přes šifrované kanály.',
  step3Title: 'Získej',
  step3Body: 'Klíč doručen okamžitě do vašeho terminálu.',

  // Stats strip
  statPlayers: 'Hráči',
  statTitles: 'Tituly',
  statDelivery: 'Doručení',
  statFailure: 'Selhání',

  // States
  loading: 'Načítání katalogu…',
  empty: 'Momentálně nejsou k dispozici žádné nabídky.',
};
